import { authActionsDefinitions } from '../feature/auth/auth.context'

const actionsContext = {
  auth: authActionsDefinitions,
}

export default actionsContext
